import { ApiError } from '@ppay/client'

export class InvoiceNotExistError extends ApiError {
  constructor(message = 'Invoice not exist') {
    super(message)
  }
}
